<template>
  <div
    class="v-iconResultMessage"
    :class="messageClass"
  >

    <div class="v-iconResultMessage__icons">

      <div :class="iconSvgName == 'amilIcon' ? 'icon-circle circle__amil' : 'icon-circle circle__card'">
        <slot name="mainIcon">

          <template>
            <component v-bind:is="iconComponent"/>
          </template>
        </slot>
      </div>

      <div class="icon-circle circle__thumb" v-if="!removeIcon">
        <span
          class="di"
          :class="thumbClass"
        />
      </div>
    </div>

    <h1>
      <span
        v-for="(item, index) in message"
        :key="index"
      >
        {{ item }}
      </span>
    </h1>
  </div>
</template>

<script>
export default {
  name: 'VIconResultMessage',
  props: {
    type: String,
    message: Array,
    iconSvgName: String,
    removeIcon: Boolean
  },
  computed: {
    icon() {
      return this.iconSvgName || 'creditCard';
    },

    messageClass() {
      let messageClass = '';
      messageClass += this.type === 'success'
        ? 'v-iconResultMessage--success'
        : 'v-iconResultMessage--error';

      messageClass += this.iconSvgName === 'PixIcon' ? ' v-iconResultMessage__pix' : '';

      messageClass += this.iconSvgName === 'amilIcon' && this.type === 'success' ? ' v-iconResultMessage__amil--success' : ' v-iconResultMessage__amil--error';

      return messageClass;
    },

    thumbClass() {
      const thumbClass = this.type === 'success'
        ? 'di-icon-check'
        : 'di-icon-close';

      return thumbClass;
    },

    iconComponent() {
      return `${this.icon}Svg`;
    },
  }
};
</script>

<style lang="scss" scoped>
.v-iconResultMessage {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;

  &__icons {
    position: relative;
    margin: 30px;
  }

  &--error {
    .circle__card {
      background-color: var(--color-error-lighten-3);

      & svg path {
        fill: var(--color-error);
      }
    }

    .circle__amil {
      background-color: var(--color-error-lighten-3);
    }

    .circle__thumb {
      background-color: var(--color-error);
    }
  }

  &--success {
    .circle__card {
      background-color: var(--color-success-lighten-3);

      & svg path {
        fill: var(--color-success);
      }
    }

    .circle__amil {
      background-color: var(--color-success-lighten-3);
    }

    .circle__thumb {
      background-color: var(--color-success);
    }
  }

  &__pix {
    & svg path {
      fill: #5FB9AD !important;
    }
  }

  &__amil {
    background-color: transparent;

    &--error {
      h1 {
        span {
          font-weight: 500 !important;
          font-size: 24px;
          line-height: 28px;
        }
      }
    }

    &--success {
      h1 {
        span {
          color: #2DA853 !important;
          max-width: 210px;
          font-weight: 500 !important;
          font-size: 24px;
          line-height: 28px;
        }
      }
    }
  }

  .circle__card {
    height: 112px;
    width: 112px;
  }

  .circle__thumb {
    position: absolute;
    bottom: -5px;
    right: 0;
    border: 4px solid #ffffff;
    height: 39px;
    width: 39px;

    .di-icon-check:before,
    .di-icon-close:before {
      font-size: 14px;
      color: #ffffff;
    }
  }

  h1 {
    display: flex;
    flex-direction: column;
    text-align: center;
  }
}
</style>
